import React from "react";
import Icon from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import Button from "components/ui/button/Button";
import { EllipsisTooltipText } from "lib/core_components/EllipsisTooltip";
import { SavedViewType } from "lib/generated/app-api";
import HolderIcon from "lib/icons/Holder";
import { assert } from "lib/utils";
import { useUnpinView } from "../../../lib/hooks/api/notices/views/useUnpinView";
import { useMyFeedPageState } from "../useMyFeedPageState";

import css from "./PinnedViewItemMini.module.scss";

type Props = {
  view: SavedViewType;
};

function PinnedViewItem({ view }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: view.id || "",
  });
  const { setSelectedView } = useMyFeedPageState();

  const { mutate: unpinViewMutation, isLoading } = useUnpinView();

  return (
    <div
      key={view.id}
      className={css.savedViewItem}
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
      }}
      {...attributes}
      {...listeners}
      aria-label="pinned view"
      onClick={() => setSelectedView(view.id || "", view.name)}
      role="button"
    >
      <div className={css.holderContainer}>
        <Icon
          aria-label="drag target"
          component={HolderIcon}
          className={css.holderIcon}
          key={view.name}
        />
      </div>
      <EllipsisTooltipText fullText={view.name} containerClassname={css.paneViewTitle} />
      {/* The button is here to unpin the view */}
      <Button
        as="button"
        icon="pin02Filled"
        className={css.pinnedIcon}
        aria-label="toggle pinned view"
        buttonType="tertiary"
        buttonStyle="inverse"
        onClick={(event) => {
          event.stopPropagation();
          assert(view.id);
          unpinViewMutation({ id: view.id, name: view.name });
        }}
        loading={isLoading}
      />
    </div>
  );
}

export default PinnedViewItem;
